import React, { useState, useEffect } from "react";

const isAddressFieldEqual = (a, b) => {
  if (a === b) return true;
  if (!a || !b) return false;
  const normalize = (val) => {
    if (typeof val === 'object') {
      if (val._id) return val._id.toString();
      if (val.name) return val.name.toString();
    }
    return val.toString();
  };
  return normalize(a) === normalize(b);
};

function LinkForm({ user, closeModal }) {
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (user) {
      const userId = user?._id;
      const { presentAddress = {}, permanentAddress = {} } = user || {};
      const isMatching = ["mohalla", "state", "district", "policeStation", "pinCode"].every(
        (field) => isAddressFieldEqual(presentAddress[field], permanentAddress[field])
      );
      if (isMatching) {
        const encodedUserId = btoa(userId); // Encode the userId using Base64
        // const generatedLink = `https://pehchan.accredipath.com/match-form/${encodedUserId}`;
        const generatedLink = `http://localhost:3000/match-form/${encodedUserId}`;
        setMessage(`${generatedLink}`);
        setLink(generatedLink);
      } else {
        const encodedUserId = btoa(userId); // Encode the userId using Base64
        // const generatedLink = `https://pehchan.accredipath.com/form/${encodedUserId}`;
        const generatedLink = `http://localhost:3000/form/${encodedUserId}`;
        setMessage(`${generatedLink}`);
        setLink(generatedLink);
      }
    }
  }, [user]);
  return (
    <div
      className="modal fade edit-box show d-block"
      id="editModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Verification Link
            </h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ textAlign: "center", fontWeight: "500" }}>
            <h4>{message}</h4>
            <br />
            {link && (
              <div>
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                  style={{ marginRight: "10px" }}
                >
                  Open Link in New Tab
                </a>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkForm;
